"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChrootContext = void 0;
/**
 * 类似 linux 的 chroot，
 * 在这个下面的 DataFormField 的 path 默认都认为是相对于这个 ChrootContext 的 stub 的
 */
class ChrootContext {
    constructor({ stub, parentChroot = null, readonly = false }) {
        this.stub = stub;
        this.path = stub.path;
        this.parentChroot = parentChroot;
        this.readonly = !!(readonly || (parentChroot === null || parentChroot === void 0 ? void 0 : parentChroot.readonly));
    }
}
exports.ChrootContext = ChrootContext;
//# sourceMappingURL=chroot.js.map